import { useBlocNext } from "@blac/react";
import styled from "@emotion/styled";
import type { FC } from "react";
import React, { useEffect, useMemo } from "react";
import { useParams } from "react-router-dom";
import AppViewCubit from "src/state/AppViewCubit/AppViewCubit";

import SignupCubit from "src/state/SignupCubit/SignupCubit";
import type { SignupCustomPageParameters } from "src/ui/components/SignupCustomContent/SignupCustom.types";
import SignupCustomContent from "src/ui/components/SignupCustomContent/SignupCustomContent";
import SignupCustomBloc from "src/ui/components/SignupCustomContent/state/SignupCustomBloc";
import SessionConfirmationCheck from "src/ui/components/SessionConfirmationCheck/SessionConfirmationCheck";
import AppHeader from "src/ui/components/AppHeader/AppHeader";
import BlockingLoadingOverlayController from "src/ui/components/BlockingLoadingOverlay/BlockingLoadingOverlayController";

const PageWrap = styled.div``;

const SignupCustomPage: FC = () => {
  useEffect(() => {
    // ensure any existing loading overlays are removed
    BlockingLoadingOverlayController.endAllLoadings();
    SignupCubit.loadSupportChat();
    return SignupCubit.removeSupportChat;
  }, []);
  const parameters = useParams<SignupCustomPageParameters>();
  const queryStrings = new URLSearchParams(window.location.search);
  const isDemoFunnel = window.location.pathname.startsWith("/demo/signup");
  const [
    { hideProgressBar },
    {
      coBrandedLogo,
      campaignSteps,
      currentStep,
      coBrandedLogoSize,
      customLogo,
      checkForOtherFunnelSubscriptions
    }
  ] = useBlocNext(SignupCustomBloc, {
    props: {
      parameters,
      options: {
        preview: queryStrings.get("preview") === "true",
        demo: isDemoFunnel
      }
    }
  });

  const [{ partnerSession }] = useBlocNext(AppViewCubit);
  const progressPercent = useMemo(() => {
    const totalSteps = campaignSteps ?? [];
    const currentStepIndex =
      totalSteps.findIndex((step) => step === currentStep) + 1;

    return (currentStepIndex / totalSteps.length) * 100;
  }, [parameters.campaign, parameters.step]);

  useEffect(() => {
    void checkForOtherFunnelSubscriptions();
  }, []);

  return (
    <PageWrap>
      <SessionConfirmationCheck />

      {!partnerSession && (
        <AppHeader
          progress={hideProgressBar ? undefined : progressPercent}
          partnerLogo={
            coBrandedLogo
              ? coBrandedLogo + "?mock-type=.png&w=200&format=auto"
              : undefined
          }
          partnerLogoSize={coBrandedLogoSize === "large" ? "large" : "default"}
          customLogo={customLogo ?? undefined}
        />
      )}

      <SignupCustomContent />
    </PageWrap>
  );
};

export default SignupCustomPage;
